export enum ObjectiveCategoryEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  TEAM = 'TEAM',
  ORGANIZATION = 'ORGANIZATION',
}

export enum ObjectiveTypeEnum {
  PERFORMANCE = 'PERFORMANCE',
  GROWTH = 'GROWTH',
}

export enum KraMetricsEnum {
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  PERCENTAGE = '%',
  UNIT = 'UNIT',
}

export enum ObjectiveAttentionTypeEnum {
  DELAYED = 'Delayed',
  AT_RISK = 'At_Risk',
  ENDING_SOON = 'Ending_Soon',
  STALE = 'Stale',
  NO_GROWTH_OBJECTIVE = 'No_Growth_Objective',
}

export enum ObjectiveStatusEnum {
  DRAFT = 'Draft',
  ON_TRACK = 'On_Track',
  TODO = 'Todo',
  ARCHIVED = 'Archived',
  COMPLETED = 'Completed',
  DELAYED = 'Delayed',
  AT_RISK = 'At_Risk',
  PENDING_REVIEW = 'Pending_Review',
}
